
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_45399","data-name":"Group 45399","transform":"translate(2337.882 7024.707)"}},[_c('path',{attrs:{"id":"Path_32458","data-name":"Path 32458","d":"M3.249 2.4a.561.561 0 00-.565.151.594.594 0 00-.139.581l1.85 6.16h6.479a.585.585 0 010 1.169h-6.48l-1.85 6.16a.594.594 0 00.139.581.561.561 0 00.565.151 45.6 45.6 0 0014.033-7 .593.593 0 000-.949 45.6 45.6 0 00-14.033-7z","transform":"translate(-2340.401 -7027.082)","fill":"#fff"}}),_c('rect',{attrs:{"id":"Rectangle_15242","data-name":"Rectangle 15242","width":"14.239","height":"14.589","transform":"translate(-2337.501 -7024.501)","fill":"none"}})])])
          )
        }
      }
    